import { useEffect, useState } from 'react';

const useIsLoading = (timeout = 500) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, timeout);

    return () => clearTimeout(timer);
  }, []);

  return isLoading;
};

export default useIsLoading;
